interface LoaderOptionProps {
  isLoading: boolean;
}

export const LoaderOption = ({ isLoading }: LoaderOptionProps) => (
  <div className="flex items-center justify-center py-2 px-4">
    {isLoading ? (
      <>
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-violet-500" />
        <span className="ml-2 text-sm text-zinc-400">Loading more...</span>
      </>
    ) : (
      <span className="text-sm text-zinc-400">Load more</span>
    )}
  </div>
);
